module.exports = __webpack_public_path__ + "static/img/アセット 41@2x.de9ba37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 41@2x.png
// module id = mMAS
// module chunks = 1